<template>
  <div class="geoproceso-form form-section">
    <!-- MODO DE SELECCIÓN -->
    <GeoprocesoSelectorModo v-model="otrasCapas" @input="onModeChange" />

    <!-- SELECCIÓN DE CAPA (Si aplica) -->
    <GeoprocesoSelectorCapa 
      v-model="capaOtrasSeleccionada"
      :otrasCapas="otrasCapas"
      :tipoInfluencia="'Radial'"
      :distancias="distancias"
      :dissolve="dissolve"
      @selection-complete="onSelectionComplete"
    />

    <!-- HERRAMIENTAS DE DIBUJO (Si aplica) -->
    <div v-if="!otrasCapas">
      <label>Ubique un punto</label>
      <button class="draw-btn" @click="drawPoint">●</button>
    </div>

    <label>Ingrese N° de radios o áreas de influencia:</label>
    <select v-model.number="radioSeleccionado">
      <option disabled value="">[Seleccione]</option>
      <option v-for="r in radios" :key="r" :value="r">{{ r }}</option>
    </select>

    <!-- 🔹 Inputs dinámicos -->
    <div v-if="radioSeleccionado" class="distancias">
      <label>Ingrese distancias: (m)</label>
      <div class="distancia-inputs">
        <input v-for="(dist, index) in distancias" :key="index" type="number" :value="dist" min="1"
          placeholder="Distancia" @input="updateDistancia(index, $event.target.value)" />
      </div>
    </div>

    <GeoprocesoOpcionesGenerales
      :capas.sync="capas"
      :metodo.sync="metodo"
      :capasSeleccionadas.sync="capasSeleccionadas"
      :dissolve.sync="dissolve"
    />
  </div>
</template>

<script>
import GeoprocesoBaseMixin from '@/components/mapTools/geoprocessings/mixins/GeoprocesoBaseMixin';
import GeoprocesoDistanciaMixin from '@/components/mapTools/geoprocessings/mixins/GeoprocesoDistanciaMixin';
import GeoprocesoOpcionesGenerales from '@/components/mapTools/geoprocessings/forms/GeoprocesoOpcionesGenerales';
import GeoprocesoSelectorModo from '@/components/mapTools/geoprocessings/forms/GeoprocesoSelectorModo';
import GeoprocesoSelectorCapa from '@/components/mapTools/geoprocessings/forms/GeoprocesoSelectorCapa';

export default {
  name: 'InfluenciaRadialForm',
  components: { GeoprocesoOpcionesGenerales, GeoprocesoSelectorModo, GeoprocesoSelectorCapa },
  mixins: [GeoprocesoBaseMixin, GeoprocesoDistanciaMixin],
  data() {
    return {
      capaOtrasSeleccionada: '',
      seleccionInfo: null,
    };
  },
  methods: {
    drawPoint() {
      this.$emit('changeDrawType', { name: 'Punto', code: 'Point' });
    },
    currentPayload() {
      return {
        ...this.getCommonPayload(),
        radioSeleccionado: this.radioSeleccionado,
        distancias: this.distancias.filter((v) => v > 0),
        capaOtrasSeleccionada: this.capaOtrasSeleccionada,
        seleccionInfo: this.seleccionInfo,
      };
    },
    onSelectionComplete(data) {
      this.seleccionInfo = data;
      this.emitState();
    },
  },
};
</script>

<style src="./_geoproceso-forms.css"></style>
